import { ApolloClient, gql, InMemoryCache } from "@apollo/client"
import { HttpLink } from "@apollo/client/link/http"
import {
  ApolloClient as StreamingApolloClient,
  InMemoryCache as StreamingInMemoryCache,
} from "@apollo/client-integration-nextjs"

import { AppSettings } from "@/settings"

let browserApolloClient = null

/**
 * Factory function for creating Apollo Client for ApolloNextAppProvider
 * Used by the ApolloProvider for client-side streaming SSR
 */
function makeClient() {
  const httpLink = new HttpLink({
    uri: AppSettings.fqlUri(),
    credentials: "same-origin",
    fetchOptions: { cache: "no-store" },
  })

  return new StreamingApolloClient({
    link: httpLink,
    cache: new StreamingInMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: "no-cache",
      },
      query: {
        fetchPolicy: "no-cache",
      },
    },
  })
}

/**
 * Creates a browser-side Apollo client using HttpLink
 * This makes HTTP requests to the /fql GraphQL endpoint
 * Used when calling getGqlClient() from client components
 */
function createBrowserClient() {
  const httpLink = new HttpLink({
    uri: AppSettings.fqlUri(),
    credentials: "same-origin",
  })

  return new ApolloClient({
    link: httpLink,
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: "no-cache",
      },
      query: {
        fetchPolicy: "no-cache",
      },
    },
  })
}

/**
 * Get the browser Apollo client singleton
 * Used by getGqlClient() when running in browser context
 */
function getBrowserClient() {
  if (!browserApolloClient) {
    browserApolloClient = createBrowserClient()
  }
  return browserApolloClient
}

export { getBrowserClient, gql, makeClient }
